/**
 * O cabeçalho de página do padrão (DESIGN.md, "Cabeçalho de página"): o mesmo topo em todas as telas
 * do app. À esquerda, o caminho (opcional), o título e o subtítulo; à direita, as ações, com a
 * principal por último. O título é um h1, a não ser que a página já tenha um.
 */
import type { ReactNode } from 'react';

export function PageHeader({
  title,
  subtitle,
  crumbs,
  actions,
  titleId,
  level = 1,
  className,
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  crumbs?: ReactNode;
  actions?: ReactNode;
  titleId?: string;
  level?: 1 | 2;
  className?: string;
}) {
  const Title = level === 1 ? 'h1' : 'h2';
  return (
    <header className={`rd-pageHead${className ? ` ${className}` : ''}`}>
      <div className="rd-pageHead__text">
        {crumbs ? <div className="rd-pageHead__crumbs">{crumbs}</div> : null}
        <Title id={titleId} className="rd-pageHead__title">
          {title}
        </Title>
        {subtitle ? <p className="rd-pageHead__sub">{subtitle}</p> : null}
      </div>
      {actions ? <div className="rd-pageHead__actions">{actions}</div> : null}
    </header>
  );
}
